import React, { memo } from 'react';
import { BrainIcon, BookOpenIcon, TargetIcon, MoonIcon, HeartIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: BrainIcon,
    title: 'Chiarezza mentale',
    description: 'Riduci i "vuoti", ritrovi prontezza nelle parole.'
  }, {
    icon: BookOpenIcon,
    title: 'Memoria affidabile',
    description: 'Ricordi nomi, date e piccoli dettagli utili.'
  }, {
    icon: TargetIcon,
    title: 'Focus costante',
    description: 'Segui conversazioni senza perdere il filo.'
  }, {
    icon: MoonIcon,
    title: 'Sonno & serenità',
    description: 'Dormi meglio, la memoria si consolida.'
  }, {
    icon: HeartIcon,
    title: 'Presenza con chi ami',
    description: 'Ti senti più sicuro, più te stesso.'
  }];
  return <section id="benefici" className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center" data-id="element-25">
          Benefici concreti che sentirai nella quotidianità
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-26">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="flex items-start space-x-4" data-id="element-27">
                <div className="flex-shrink-0" data-id="element-28">
                  <Icon className="w-10 h-10 text-green-600" data-id="element-29" />
                </div>
                <div data-id="element-30">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2" data-id="element-31">
                    {benefit.title}
                  </h3>
                  <p className="text-lg text-gray-700" data-id="element-32">{benefit.description}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}